import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles/createTheme';

export const ERROR_BOUND_CONTAINER: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  padding: '24px',
  top: '0px',
  left: '0px',
  position: 'fixed',
  background: 'white',
  zIndex: 10000000,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto'
};
export const ERROR_BOUND_INNER_CONTAINER: SxProps<Theme> = {
  maxWidth: '360px',
  height: '100%',
  position: 'relative'
};
export const ERROR_BOUND_TITLE_STYLE: SxProps<Theme> = {
  textAlign: 'center',
  fontSize: '24px',
  margin: '0px',
  padding: '0px',
  marginBottom: '12px'
};
export const ERROR_BOUND_NAME_STYLE: SxProps<Theme> = {
  fontSize: '20px',
  margin: '0px',
  padding: '0px',
  marginBottom: '12px'
};
export const ERROR_BOUND_CONTENT_STYLE: SxProps<Theme> = {
  fontSize: '16px',
  whiteSpace: 'pre-wrap',
  margin: '0px',
  padding: '0px',
  marginBottom: '12px'
};
export const ERROR_BOUND_CONTENT1_STYLE: SxProps<Theme> = {
  fontSize: '16px',
  whiteSpace: 'pre-wrap',
  margin: '0px',
  padding: '0px'
};
